<template>
  <v-col cols="12" md="4">
    <h4 class="ma-3">Imagem do Aluno</h4>

    <v-hover v-slot="{ hover }">
      <v-card
        style="width: 205px; margin-left: 20%"
        :elevation="hover ? 12 : 2"
        :class="{ 'on-hover': hover }"
      >
        <v-img :src="imgAlunoCard" height="205px" width="205px">
          <v-card-title
            v-if="imgAlunoCard && imgAlunoCard !== '/placeholde-aluno.jpeg'"
            class="text-h6 white--text"
          >
            <v-row class="fill-height flex-column" justify="space-between">
              <div class="align-self-center">
                <v-btn
                  style="margin-bottom: 10px"
                  @click="abrirImagem(imgAluno)"
                  :class="{ 'show-btns-down': hover }"
                  :color="transparent"
                  plain
                >
                  <v-icon :class="{ 'show-btns-down': hover }" :color="transparent">
                    file_download
                  </v-icon>
                  Baixar
                </v-btn>
                <v-btn
                  @click="removerImagemAluno"
                  :class="{ 'show-btns': hover }"
                  :color="transparent"
                  plain
                >
                  <v-icon :class="{ 'show-btns': hover }" :color="transparent"> delete </v-icon>
                  Remover
                </v-btn>
              </div>
            </v-row>
          </v-card-title>
        </v-img>
      </v-card>
    </v-hover>

    <v-file-input
      v-model="fileImagemAluno"
      accept="image/png, image/jpeg"
      :max-size="2097152"
      class="mt-5"
      label="Imagem do Aluno"
      filled
      prepend-icon="mdi-camera"
      outlined
      @change="uploadImagemAluno($event)"
    />

    <e-modal-cortar-imagem
      :dialogProp="cortarImagemDialogAluno"
      :img="imgAluno"
      @atualizar-imagem-aluno="atualizarImagemAluno($event)"
    />
  </v-col>
</template>

<script>
import EModalCortarImagem from "./EModalCortarImagem.vue";

export default {
  name: "EUploadsImages",
  components: { EModalCortarImagem },
  props: {
    dadosImgAluno: {
      type: String,
      default: null,
    },
  },
  data: () => ({
    fileImagemAluno: null,
    imgAluno: `${process.env.BASE_URL}placeholde-aluno.jpeg`,
    imgAlunoCard: `${process.env.BASE_URL}placeholde-aluno.jpeg`,
    cortarImagemDialogAluno: false,
    transparent: "rgba(255, 255, 255, 0)",
  }),
  watch: {
    dadosImgAluno(value) {
      this.imgAluno = value || `${process.env.BASE_URL}placeholde-aluno.jpeg`;
      this.imgAlunoCard = value || `${process.env.BASE_URL}placeholde-aluno.jpeg`;
    },
  },
  methods: {
    abrirImagem(img) {
      if (img) {
        window.open(img, "_blank");
      }
    },
    removerImagemAluno() {
      this.fileImagemAluno = null;
      this.imgAluno = `${process.env.BASE_URL}placeholde-aluno.jpeg`;
      this.imgAlunoCard = `${process.env.BASE_URL}placeholde-aluno.jpeg`;
      this.$emit("imagem-aluno-form", { url: "", name: "" });
    },
    async uploadImagemAluno(file) {
      if (!file) {
        return;
      }

      try {
        const data = await this.$services.alunosService.uploadImageAluno(file);
        if (!data.nameFile) {
          this.cortarImagemDialogAluno = false;
          this.imgAluno = `${process.env.BASE_URL}placeholde-aluno.jpeg`;
          this.imgAlunoCard = `${process.env.BASE_URL}placeholde-aluno.jpeg`;
          return;
        }

        this.imgAluno = data.nameFile;
        this.cortarImagemDialogAluno = true;
      } catch (error) {
        this.$handleError(error);
        this.fileImagemAluno = null;
      }
    },
    atualizarImagemAluno(dado) {
      this.imgAluno = dado.url || `${process.env.BASE_URL}placeholde-aluno.jpeg`;
      this.imgAlunoCard = this.imgAluno;
      this.cortarImagemDialogAluno = false;
      this.$emit("imagem-aluno-form", dado);
    },
  },
};
</script>

<style scoped>
.v-card {
  transition: opacity 0.4s ease-in-out;
}

.v-card:not(.on-hover) {
  opacity: 0.9;
}

.show-btns {
  color: rgb(173, 9, 9) !important;
  background-color: white;
}

.show-btns-down {
  color: rgb(8, 125, 66) !important;
  background-color: white;
  margin-right: 4px;
}
</style>
